import _defineProperty from "@babel/runtime/helpers/defineProperty";
import StyleTypes from '../../../types/StyleTypes';
export default {
  html: _defineProperty({}, StyleTypes.HIGHLIGHT, 'mark'),
  markdown: _defineProperty({}, StyleTypes.HIGHLIGHT, function (_ref) {
    var children = _ref.children;
    return "<mark>".concat(children, "</mark>");
  })
};